import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { ToneSection } from '@/components/generals/tone'
import { HomeHero } from '@/components/landing/home/hero'
import { Manifesto } from '@/components/landing/home/manifesto'
import { TwoPercent } from '@/components/landing/home/two-percent'
import { Guarantees } from '@/components/landing/home/guarantees'
import { Arsenal } from '@/components/landing/home/arsenal'
import { Insured } from '@/components/landing/home/insured'
import { IndustriesIndex } from '@/components/landing/home/industries-index'
import { ClientStrip } from '@/components/landing/shared/client-strip'
import { Testimonials } from '@/components/landing/shared/testimonials'
import { MustHaves } from '@/components/landing/shared/must-haves'
import { homeClients, testimonials } from '@/constants/content'

const Home: FC = (): ReactNode => {
    return (
        <Layout tone='void'>
            <Seo />

            <HomeHero />

            <ToneSection tone='void' id='clients'>
                <ClientStrip clients={homeClients} aside='Crypto · Gaming · Prepaid & Gift Cards' />
            </ToneSection>

            <Manifesto />
            <TwoPercent />
            <Guarantees />
            <Arsenal />
            <Insured />
            <Testimonials items={testimonials} tone='paper' />
            <IndustriesIndex />
            <MustHaves tone='ink' />
        </Layout>
    )
}

export default Home
